import { ThirdPartyButton } from "swp-react";

import FormattedMessage from "./FormattedMessage";
import { logToAi } from "@/utils/logging";


const HelpButton = ({
    messageId,
    iconSrc,
    onClick = null,
    recommended = false,
}) => {
    return (
        <ThirdPartyButton fullWidth onClick={() => { 
            logToAi(
                {
                    message: `Clicked help topic button with messageId '${messageId}'!`,
                    id: 'SELECTED_HELP_TOPIC',
                    location: 'HelpPage.jsx:onClick',
                    data: {
                        messageId: messageId,
                    }
                }, 
                'debug'
            ); 
            onClick(); 
        }} className="help-button">
            { recommended && 
                <div className="help-button-recommended">
                    <FormattedMessage id='button-recommended' classoverride='help-button-recommended-text'/>
                </div>
            }
            <div className="help-button-inner">
                { iconSrc && <img className="alert-icon" src={iconSrc} /> }
                <FormattedMessage id={messageId}/>
            </div>
        </ThirdPartyButton>
    )
}

export default HelpButton;